
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import ImageBase from '@/components/atoms/ImageBase.vue'
import LabelBase from '@/components/atoms/LabelBase.vue'
import { DrawingModel } from '@/models/DrawingModel'
import { PenSetting } from '@/const/PenSetting'

/**
 * 手書き入力用ペン切り替え部品
 */
@Component({
  components: {
    ImageBase,
    LabelBase,
  },
})
export default class TogglePen extends Vue {
  /** ペンの切り替え時処理 */
  @Prop()
  private togglePen!: (activePen: DrawingModel.PenAsset) => void

  /** 選択されているペン */
  private selectedValue: string = PenSetting.PEN_BLACK.name

  /**
   * 選択中のペン情報
   *
   * @returns ペン情報
   */
  private get activePen(): DrawingModel.PenAsset {
    if (this.selectedValue === PenSetting.ERASER.name) {
      return PenSetting.ERASER
    }

    return PenSetting.PEN_BLACK
  }

  /**
   * ペンの切り替え時処理
   */
  @Watch('selectedValue')
  private changePenEvent(): void {
    this.togglePen(this.activePen)
  }
}
